import React from 'react';

interface LoadingAnimationProps {
  onComplete: () => void;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({ onComplete }) => {
  React.useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div 
      className="fixed inset-0 flex flex-col items-center justify-center bg-gray-900 z-50"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div className="relative w-40 h-40">
        <img 
          src="/nacme_logo.jpg" 
          alt="NACME Logo" 
          className="w-full h-full object-contain"
        />
      </div>
      <div className="mt-4 text-2xl text-[#4F46E5] animate-pulse">
        Loading...
      </div>
    </div>
  );
};

export default LoadingAnimation; 